import React from 'react';
import { Folder, File, FileText } from 'lucide-react';

import TableRowActions from './TableRowActions';

const renderIcon = (item) => {
  switch (item.type) {
    case 'folder':
      return <Folder size={18} color="#F4B400" />;

    case 'file':
      if (item.extension === 'pdf') {
        return <FileText size={18} color="#EA4335" />;
      }

      return <File size={18} color="#4285F4" />;

    default:
      return <File size={18} color="#4285F4" />;
  }
};

const Status = ({ status }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 70,
      padding: '4px 10px',
      borderRadius: 20,
      background: '#EEF7EE',
      color: '#2E7D32',
      fontSize: 12,
      fontWeight: 500,
    }}
  >
    {status}
  </span>
);

const columns = [
  {
    accessorKey: 'icon',
    header: '',
    size: 50,
    cell: ({ row }) => renderIcon(row.original),
  },

  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => row.original.name,
  },

  {
    accessorKey: 'type',
    header: 'Type',
    cell: ({ row }) =>
      row.original.type === 'folder' ? 'Folder' : row.original.extension?.toUpperCase() || 'File',
  },

  {
    accessorKey: 'modified',
    header: 'Modified',
  },

  {
    accessorKey: 'size',
    header: 'Size',
  },

  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => <Status status={row.original.status} />,
  },

  {
    id: 'actions',
    header: '',
    size: 140,
    cell: ({ row }) =>
      row.original.type === 'file' ? <TableRowActions item={row.original} /> : null,
  },
];

export default columns;
